<!-- 首頁特色機種清單內容 -->
<template>
  <a :href="motor.showcaseAd.link || 'javascript: void(0)'" v-if="motor && large && motor.showcaseAd" :title="motor.slogan" class="">
    <div class="promotion-image link-zoom-image">
      <div class="ui placeholder" v-if="!current.loaded">
        <div class="square image"></div>
      </div>
      <img @load="onLoad" :src="motor.showcaseAd.image" :alt="motor.name" />
    </div>
  </a>
  <a :href="motor.url" target="_blank" class="motor" v-else-if="motor" :key="motor.id" data-ga-label="特色車款"  :class="getClasses(motor)" :alt="motor.name" :title="motor.name">
    <div class="label" v-if="motor.styleNames.length > 0">{{ motor.styleNames[0] }}</div>
    <div class="ui placeholder" v-if="!current.loaded">
      <div class="square image"></div>
    </div>
    <div class="cover link-zoom-image">
      <img @load="onLoad" :src="motor.coverImages[large ? 600 : 300]" :alt="motor.slogan" />
    </div>
    <div class="meta">
      <div class="name">{{ motor.name }}</div>
      <div class="slogan">{{ motor.slogan }}</div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    motor: Object,
    large: Boolean,
    ative: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      current: {
        loaded: false,
      },
    }
  },
  computed: {},
  methods: {
    onLoad() {
      this.current.loaded = true
    },
    getClasses(motor) {
      const isIonex = motor.features.indexOf('ionex')
      if (isIonex >= 0) {
        return ''
      } else {
        return motor.features
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
.motor
  margin 1rem
  display flex
  flex-direction column
  align-items center
  justify-content center
  .promotion-image
    width 100%
    border-radius 20px
    overflow hidden
    position relative
    margin -1rem
    height calc(100% + 2rem)
    width calc(100% + 2rem)
    display flex
    align-items center
    justify-content center
    img
      width 100%
      height auto
  .label, .slogan
    display none
  .cover
    width 100%
    height 100%
    position relative
    img
      width 100%
      height auto
      position absolute
      left 50%
      top 40%
      transform translate(-50%, -40%)
  &:hover img
    transform translate(-50%, -50%) scale(1.05)
  &[data-category = "ATV"] .cover img
    top 50%
    transform translate(-50%, -50%)
  &[data-category = "ATV"] .name
    top 88%
  .meta
    text-align center
  .ui.placeholder
    position absolute
    left 0
    right 0
    top 0
    max-width 100%
  .name
    font-size 1.4rem
    line-height 1.4
    position absolute
    width 100%
    top 80%
    left 50%
    transform translate(-50%, -50%)
    padding: 0 0.25em;
    @media (max-width 767px)
      font-size 1.2rem
//標籤設定
.motor:after
  position absolute
  left 12px
  top 7px
  padding .1em .5em
  text-indent -9999px
  background-position right top
  background-repeat no-repeat
  background-size 100%
  display inline-block
  font-size .8em
  color white
.motor.cbs-sale:after
    content "售完為止"
    background-image url(https://www.kymco.com.tw/storage/app/media/images/soldout_icon.png)
    width 40px
    height 45px
.motor.new:after
  content "NEW"
  width 53px
  height 35px
  background-image url('~@/assets/site/motors-icon/new-icon.png')
  @media (max-width 767px)
    width 10vw
    height 6.64vw
.motor.sale:after
  content "ON SALE"
  background-color #EC1C24
  text-indent unset

.motor.abs:after
  content ""
  background-image url(http://www.kymco.com.tw/storage/app/media/images/abs-icon.png)
  width 56px
  height 27px

.motor.ionex:after
  content ""
  top 10px
  background-image url(http://www.kymco.com.tw/storage/app/media/images/ionex-icon.png)
  width 86px
  height 22px

.motor.seven-month:after
  content ""
  background-image url(https://www.kymco.com.tw/storage/app/media/images/7-month-icon.png)
  width 40px
  height 40px

.motor.sixTh:after
  content "六期 環保標準"
  background-image url(https://www.kymco.com.tw/storage/app/media/images/6th.png)
  width 35px
  height 57px

.motor.roar:after
  content "轟動時刻"
  background-image url('~@/assets/site/motors-icon/roar-icon.svg')
  width 80px
  height 57px
  top 12px
</style>
